<template>
    <DateRanges @filterByDate="$emit('filterByDate', $event)" :date="date"/>
    <table id="datatable" class="table table-striped table-hover rounded-4 overflow-hidden my-5 w-100">
        <thead>
            <tr>
                <th class="no-sort"></th>
                <th class="text-center text-nowrap" role="button">
                    <i class="fa-solid fa-file-invoice-dollar me-2"></i>
                    {{ $t('DataTable.labels.receipt') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-book-atlas me-2"></i>
                    {{ $t('DataTable.labels.id') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-credit-card me-2"></i>
                    {{ $t('DataTable.labels.truncated_pan') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-fingerprint me-2"></i>
                    {{ $t('DataTable.labels.token') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-coins me-2"></i>
                    {{ $t('DataTable.labels.amount') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-credit-card me-2"></i>
                    {{ $t('DataTable.labels.status') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-clock me-2"></i>
                    {{ $t('DataTable.labels.created') }}
                </th>
                <th class="text-center text-nowrap">
                    <i class="fa-solid fa-clock me-2"></i>
                    {{ $t('DataTable.labels.updated') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="tr in tbody" :key="tr.id" :class="setLastCharge(tr.LastCharge.charge_results_name)">
                <td class="dtr-control text-center align-middle">
                    <i class="fa-solid fa-chevron-down"></i>
                </td>
                <td class="text-center text-nowrap align-middle">
                    <span class="btn btn-auth btn-pulse" v-if="tr.LastCharge.charge_results_name == 'SUCCEEDED'" @click="$emit('getReceipt', tr.Payments.short_id)">
                        <i class="fa-solid fa-file-pdf"></i>
                    </span>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <span class="badge rounded-pill short_id">
                        {{ tr.Payments.short_id }}
                    </span>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <div class="d-flex justify-content-center align-items-center">
                        <img :src="require(`@/assets/img/card_schemes/${tr.BankCard.label}.svg`)" class="card-scheme">
                        <span class="truncated_pan">
                            {{ tr.BankCard.truncated_pan }}
                            <i class="fa-solid fa-mobile-screen-button fs-2 ms-2" v-if="tr.BankCard.form_factors_name === 'DEVICE'"></i>
                        </span>
                    </div>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <div class="d-flex align-items-center">
                        <span class="badge rounded-pill ellipsis-item token" :title="tr.BankCard.token">
                            {{ tr.BankCard.token }}
                        </span>
                    </div>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <span class="badge rounded-pill amount">
                        {{ tr.Payments.amount }}
                    </span>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <span class="badge rounded-pill status" :class="setLastCharge(tr.LastCharge.charge_results_name)">
                        {{ tr.LastCharge.charge_results_name }}
                    </span>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <span class="badge rounded-pill created font-monospace">
                        {{ tr.Payments.created }}
                    </span>
                </td>
                <td class="text-center text-nowrap align-middle" @click="$emit('getDetails', tr)">
                    <span class="badge rounded-pill updated font-monospace">
                        {{ tr.Payments.updated }}
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import $ from 'jquery'
import DateRanges from '@/components/DateRanges.vue'
export default {
    name: 'PaymentsDataTable',
    props: {
        date: String,
        tbody: Array
    },
    emits: ['filterByDate', 'getDetails','getReceipt'],
    components: {
        DateRanges
    },
    computed: {
        setLastCharge() {
            const bg = {
                'SUCCEEDED': 'bg-success table-success',
                'FAILED': 'bg-danger table-danger',
                'default': ''
            }
            return color => bg[color] ? bg[color] : bg['default']
        }
    },
    created() {
        $(document).ready( () => {
            var PaymentsDataTable = $('#datatable').DataTable({
                dom: `<'d-flex justify-content-center justify-content-md-between align-items-center flex-wrap'
						<'col-12 col-md-4'l>
                        <'col-12 col-md-4'<"dater">>
						<'col-12 col-md-4'f>>` +
                    "<'d-flex'<'col-12'tr>>" +
                    `<'d-flex align-items-center flex-wrap'
                        <'col-12 col-md-5 text-center text-md-start'i>
                        <'col-12 col-md-7'p>>`,
                language: {
                    lengthMenu: this.$t('DataTable.lengthMenu'),
                    search: '',
                    searchPlaceholder: this.$t('DataTable.search'),
                    info: this.$t('DataTable.info'),
                    paginate: {
                        previous: '<i class="fa-solid fa-circle-chevron-left"></i>',
                        next: '<i class="fa-solid fa-circle-chevron-right"></i>'
                    },
                    zeroRecords: this.$t('DataTable.zeroRecords'),
                    infoFiltered: this.$t('DataTable.infoFiltered'),
                    infoEmpty: this.$t('DataTable.infoEmpty'),
                },
                responsive: {
                    details: {
                        type: 'column',
                        renderer: (api, rowIdx, columns) => {
                            var data = $.map(columns, (col) => {
                                if (col.hidden === false) {
                                    return ''
                                }
                                var row = $('<tr>', {
                                    'data-dt-row': col.rowIndex,
                                    'data-dt-column': col.columnIndex
                                })
                                    .append(
                                        $('<td>', {
                                            class: "py-2"
                                        })
                                            .html(col.title)
                                            .css('font-size', '14px'))
                                    .append(
                                        $('<td>', {
                                            class: col.className
                                        }).html(col.data))

                                return row.get(0).outerHTML
                            }).join('')
                            return data ? $('<table class="w-100 table-sm">').append(data) : false
                        }
                    }
                },
                columnDefs: [{
                    className: 'dtr-control',
                    orderable: false,
                    width: '0%',
                    targets: 0
                }, {
                    width: '12.5%',
                    orderable: false,
                    targets: '_all'
                }, {
                    type: 'date',
                    targets: [7,8]
                }],
                order: [
                   [8, 'desc'] 
                ]
            })
            $('.dater').append($(".dataTables_date"))
            $('input').removeClass('form-control form-control-sm')
            $('select').removeClass('form-select form-select-sm')

            PaymentsDataTable.on('responsive-resize', (e, datatable) => {
                datatable.responsive.rebuild().columns.adjust().responsive.recalc()
            })

            PaymentsDataTable.on('responsive-display', (e, api, row, showHide) => {
                var rowOpened = $(api.row(row.index()).node())
                if (showHide) {
                    rowOpened.find('td.dtr-control').empty().append(`<i class="fa-solid fa-chevron-up"></i>`)
                } else {
                    rowOpened.find('td.dtr-control').empty().append(`<i class="fa-solid fa-chevron-down"></i>`)
                }
            })
        })
    }
}
</script>

<style>

</style>